const Strings = [
  'Guitar',
  'Bass',
  'Banjo',
  'Viola',
  'Chello',
  'Violin',
  'Fiddle',
  'Harpsichord',
  'Vocals',
];

const Keyboard = ['Piano', 'Organ', 'Electronic', 'Keyboard', 'Synthesizer'];

const Brass = ['Trumpet', 'Trombone', 'Tuba', 'Horn'];

const Percussion = ['Drums', 'Cymbals', 'Tambourine', 'Cowbell', 'Xylophone'];

const Woodwind = ['Saxophone', 'Flute', 'Clarinet', 'Oboe', 'Bassoon', 'Harmonica'];

const otherSkills = [
  'Producer',
  'Mixing Engineer',
  'Mastering Engineer',
  'Engineer',
  'Songwriter',
  'Editor',
  'Video Editor',
  'Graphic Designer',
];

const dawSkills = ['Ableton', 'Pro Tools', 'Logic', 'FL Studio', 'Garage Band', 'Audacity'];

export const SkillsArray = [
  ...Strings,
  ...Keyboard,
  ...Brass,
  ...Percussion,
  ...Woodwind,
  ...otherSkills,
  ...dawSkills,
].sort();

export const GenresArray = [
  'Avant-garde',
  'Alternative Rock',
  'Anime',
  'Blues',
  'Classical',
  'Classic Rock',
  "Children's music",
  'Comedy',
  'Country',
  'Commercial',
  'Easy listening',
  'Electronic',
  'Folk',
  'Hip-Hop / Rap',
  'Holiday',
  'House',
  'Pop',
  'Religious',
  'Jazz',
  'Metal Rock ',
  'New Age',
  'Punk Rock',
  'Opera',
  'R&B / Soul',
  'Reggae',
  'Rock',
  'International',
  'Emo',
  'Pop Punk',
  'Singer-Songwriter',
  'Acoustic',
].sort();

export const MoodsArray = [
  'Action',
  'Adventurous',
  'Aggressive',
  'Airy',
  'Ambient',
  'Angelic',
  'Angry',
  'Anthemic',
  'Anxious',
  'Arcade',
  'Atmospheric',
  'Beats',
  'Beats To Rap To',
  'Beau',
  'Beautiful',
  'Black',
  'Bouncy',
  'Bright',
  'Care Free',
  'Carefree',
  'Caribbean',
  'Catchy',
  'Charm',
  'Cheerful',
  'Childlike',
  'Chilled',
  'Chilling',
  'Cinematic',
  'Clapping',
  'Classic',
  'Clumsy',
  'Cold',
  'Colorful',
  'Confident',
  'Contemplative',
  'Cool',
  'Cool Vibe',
  'Corporate',
  'Cosy',
  'Courageous',
  'Creepy',
  'Cultured',
  'Cute',
  'Dancing',
  'Danger',
  'Daring',
  'Dark',
  'Deep',
  'Depressing',
  'Determined',
  'Digital',
  'Dirty',
  'Distant',
  'Downbeat',
  'Downtempo',
  'Downtown',
  'Dramatic',
  'Dreamy',
  'Driving',
  'Dynamic',
  'Eager',
  'Earthy',
  'Eccentric',
  'Edgy',
  'Eerie',
  'Elated',
  'Electro',
  'Emotional',
  'Empowering',
  'Encouraging',
  'Energetic',
  'Epic',
  'Ethereal',
  'Euphoric',
  'Evolving',
  'Exciting',
  'Exotic',
  'Exotica',
  'Expansive',
  'Experimental',
  'Experimental,Dark',
  'Family',
  'Feel Good',
  'Festive',
  'Film',
  'Frantic',
  'Free',
  'Frightening',
  'Frisky',
  'Fun',
  'Funny',
  'Futuristic',
  'Gentle',
  'Glamorous',
  'Glitchy',
  'Good Time',
  'Groove',
  'Groovy',
  'Happy',
  'Happy Birthday',
  'Hard',
  'Haunting',
  'Heavy',
  'Heroic',
  'Holiday',
  'Homely',
  'Hopeful',
  'Humorous',
  'Hypnotic',
  'Industrial',
  'Inquisitive',
  'Inspirational',
  'Inspiring',
  'Intense',
  'Intimate',
  'Laid Back',
  'Light',
  'Lo-FI',
  'Lonely',
  'Lost',
  'Love',
  'Lustful',
  'Magical',
  'Meditative',
  'Melancholic',
  'Mellow',
  'Melodic',
  'Minimal',
  'Moody',
  'Motivational',
  'Mournful',
  'Mysterious',
  'Mystical',
  'Nervous',
  'Nostalgic',
  'Off Beat',
  'Ominous',
  'Optimistic',
  'Organic',
  'Otherworldly',
  'Passionate',
  'Peaceful',
  'Pensive',
  'Playful',
  'Poetic',
  'Positive',
  'Powerful',
  'Quirky',
  'Rebellious',
  'Reflective',
  'Regal',
  'Rejected',
  'Relaxed',
  'Relaxing',
  'Relentless',
  'Religious',
  'Restless',
  'Retro',
  'Reverb',
  'Romantic',
  'Royal',
  'Rural',
  'Rustic',
  'Sad',
  'Scary',
  'Sentimental',
  'Sexy',
  'Smoky',
  'Smooth',
  'Soft',
  'Solemn',
  'Somber',
  'Sombre',
  'Songs',
  'Sophisticated',
  'Soulful',
  'Sparse',
  'Street',
  'Sub',
  'Summer',
  'Sunny',
  'Sunshine',
  'Suspense',
  'Suspenseful',
  'Swinging',
  'Tech',
  'Techno For New Media',
  'Tense',
  'Tension',
  'Terror',
  'Thoughtful',
  'Triumphant',
  'Understated',
  'Upbeat',
  'Uplifting',
  'Uptempo',
  'Urban',
  'Urgent',
  'Utopian',
  'Vicious',
  'Vintage',
  'Vulnerable',
  'Warm',
  'WarmMagical',
  'Wild',
  'World',
  'Yearnful',
  'Yesteryear',
  'Youth',
].sort();

export const inviteList = [];
export const websiteRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
export const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
export const NUMBER_REGEX = /^\d+$/;

export const MAX_CHARACTER = 50;

export const routesWithoutFooter = [
  '/initial-setting',
  'my-tracks',
  'explore',
  'dashboard',
  'user-profile',
  'profile',
  'share-management',
  'share',
  'billing',
  'pricing-table',
  'projects',
  'project',
  'enterprise',
  '/team-management',
  '/admin/',
];

export const routesWithoutNavbar = [
  '/initial-setting',
  'my-tracks',
  'explore',
  'dashboard',
  'user-profile',
  'profile',
  'settings',
  'profile-settings',
  'not-found',
  'share-management',
  'share',
  'billing',
  'pricing-table',
  'projects',
  'project',
  'enterprise',
  '/team-management',
  '/admin/',
];

